import React, { MouseEventHandler, CSSProperties } from 'react'
import { Tooltip } from '@mui/material'
import { StyledButton } from './CardActionsStyles'

interface CardActionButtonProps {
  iconlabel?: React.ReactNode
  iconweight?: string
  iconsize?: string
  iconcolor?: string
  tooltiptitle?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children?: any
  onClick?: MouseEventHandler<HTMLDivElement>
  disabled?: boolean
  style?: CSSProperties
}

const Button = React.forwardRef(
  ({ onClick, iconsize, iconweight, iconlabel, children, disabled, style, ...props }: CardActionButtonProps, ref) => {
    const size = iconsize ? `fa-${iconsize}` : ''

    return (
      <StyledButton ref={ref} onClick={disabled ? () => {} : onClick} style={style} {...props}>
        {typeof iconlabel === 'string' ? (
          <i className={`fa-${iconweight || 'light'} fa-${iconlabel} ${size}`} />
        ) : (
          iconlabel
        )}
        {children}
      </StyledButton>
    )
  }
)

const CardActionButton = ({
  iconlabel,
  iconweight,
  iconsize,
  tooltiptitle,
  onClick,
  children,
  disabled = false,
  style,
  ...props
}: CardActionButtonProps) => {
  return tooltiptitle ? (
    <Tooltip title={tooltiptitle} placement={'top'} arrow {...props}>
      <Button onClick={onClick} iconsize={iconsize} iconweight={iconweight} iconlabel={iconlabel} disabled={disabled} style={style}>
        {children}
      </Button>
    </Tooltip>
  ) : (
    <Button onClick={onClick} iconsize={iconsize} iconweight={iconweight} iconlabel={iconlabel} disabled={disabled} style={style}>
      {children}
    </Button>
  )
}

export default CardActionButton
